/**
 * Site-wide watermark — purple runic monogram fixed across viewport.
 * Sits above section backgrounds at very low opacity so it reads as
 * a traditional institutional watermark over all content.
 */
const MARK_URL =
  "https://customer-assets.emergentagent.com/job_folks-future-ready/artifacts/fhqglbv6_image.png";

export default function Watermark() {
  return (
    <>
      {/* Massive centered watermark */}
      <div
        aria-hidden="true"
        data-testid="site-watermark"
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "min(72vmin, 820px)",
          height: "min(72vmin, 820px)",
          backgroundImage: `url(${MARK_URL})`,
          backgroundSize: "contain",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          opacity: 0.04,
          mixBlendMode: "multiply",
          pointerEvents: "none",
          zIndex: 80,
        }}
      />
    </>
  );
}
